import { FC, useCallback, useEffect, useRef, useState } from 'react';

import { Badge } from '@componentLibrary/Badge';

import CountBadge from '@components/layout/CountBadge';
import { NavLink } from '@components/router';

import { cn } from '@app/componentLibrary/utils';

import { CustomNavLinkProps } from './AppHeader.types';

const CustomNavLink: FC<CustomNavLinkProps> = ({
    text,
    url,
    isActive,
    icon,
    badgeCount,
    onClick,
    chipText,
}) => {
    const [isNavLinkActive, setIsNavLinkActive] = useState(false);
    const lastActiveState = useRef(false);
    const currentActiveState = useRef(false);

    const handleIsActive = useCallback(
        (match: any, location: any) => {
            const val = isActive?.(match, location) ?? false;
            currentActiveState.current = val;
            return val;
        },
        [isActive],
    );

    // Update state in useEffect to avoid setState during render
    useEffect(() => {
        if (currentActiveState.current !== lastActiveState.current) {
            lastActiveState.current = currentActiveState.current;
            setIsNavLinkActive(currentActiveState.current);
        }
    });

    return (
        <li className="navbar-link">
            <NavLink
                data-intercom-target={text}
                className={cn(isNavLinkActive)}
                activeClassName="nav-link-active"
                to={url}
                isActive={handleIsActive}
                onClick={onClick}
            >
                <section>
                    {icon}
                    <span>{text}</span>
                    {!!badgeCount && !isNavLinkActive && <div className="mobile-badge" />}
                </section>
                {!!badgeCount && (
                    <CountBadge
                        count={badgeCount}
                        className={cn(isNavLinkActive ? 'hidden' : '')}
                    />
                )}
                {!!chipText && (
                    <Badge color="cerulean" label={chipText} variant="solid" className="chip" />
                )}
            </NavLink>
        </li>
    );
};

export default CustomNavLink;
